import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { InputMaskDate } from '../../../Helpers/Formatters';
import { TextInput } from '../../../Helpers/Inputs';
import GenderButtons from '../../Common/SubComponents/GenderButtons';

export default function ChildInfoForm(props) {
    const onFieldChange = (field, value) => {
        // call onChange with the whole updated form
        props.onChange({ ...props.formState, [field]: value });
    };

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value, longFieldName) => {
        props.setValue(longFieldName, value);
        onFieldChange(field, value);
        props.trigger(longFieldName);
    };


    return (
        <div>
            <Fragment>
                <h6>Dependent Child {props.index + 1}</h6>
                <Form.Group>
                    <TextInput
                        name={`dependentChild[${props.index}].firstName`}
                        id={`dependentChild[${props.index}].firstName`}
                        label="First Name"
                        value={props.formState.firstName}
                        errors={props.errors && props.errors.firstName}
                        inputRef={props.register}
                        onChange={(e) => onFieldChange('firstName', e.target.value)}
                        inputProps={{
                            maxLength: 10,
                        }}
                    />
                </Form.Group>

                <Form.Group>
                    <TextInput
                        name={`dependentChild[${props.index}].middleInitial`}
                        id={`dependentChild[${props.index}].middleInitial`}
                        label="Middle Initial"
                        value={props.formState.middleInitial}
                        errors={props.errors && props.errors.middleInitial}
                        inputRef={props.register}
                        onChange={(e) => onFieldChange('middleInitial', e.target.value)}
                        inputProps={{
                            maxLength: 4,
                        }}
                    />
                </Form.Group>

                <Form.Group>
                    <TextInput
                        name={`dependentChild[${props.index}].lastName`}
                        id={`dependentChild[${props.index}].lastName`}
                        label="Last Name"
                        value={props.formState.lastName}
                        errors={props.errors && props.errors.lastName}
                        inputRef={props.register}
                        onChange={(e) => onFieldChange('lastName', e.target.value)}
                        inputProps={{
                            maxLength: 50,
                        }}
                    />
                </Form.Group>

                <Form.Group>
                    <TextInput
                        name={`dependentChild[${props.index}].dateOfBirth`}
                        id={`dependentChild[${props.index}].dateOfBirth`}
                        label="Date of Birth"
                        value={props.formState.dateOfBirth}
                        errors={props.errors && props.errors.dateOfBirth}
                        inputRef={props.register}
                        onChange={(e) => handleValueChange('dateOfBirth', e.target.value, `dependentChild[${props.index}].dateOfBirth`)}
                        InputProps={{
                            inputComponent: InputMaskDate,
                        }}
                    />
                </Form.Group>

                <Form.Group className="m-0">
                    <GenderButtons
                        name={`dependentChild[${props.index}].gender`}
                        id={`dependentChild[${props.index}].gender`}
                        selectedGender={props.formState.gender}
                        onClickMale={() => handleValueChange('gender', 'Male', `dependentChild[${props.index}].gender`)}
                        onClickFemale={() => handleValueChange('gender', 'Female', `dependentChild[${props.index}].gender`)}
                        error={props.errors && props.errors.gender}
                    />
                </Form.Group>

                {/*props.showChildRemove && (
          <Form.Group>
            <Button onClick={props.onRemove}>DELETE DEPENDENT CHILD</Button>
          </Form.Group>
        )*/}
            </Fragment>
        </div>
    );
}

ChildInfoForm.propTypes = {
    formState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/ChildInfoForm.js